<template>
  <v-container class="home-dashboard" fluid @dblclick.alt="Lucky()">
    <v-row v-if="permissions.orders">
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="dashboard-col home-recent-orders">
            <v-subheader>
              {{ lang.orders.recent }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'orders' })"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <RecentOrders />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="py-2">
        <v-row>
          <v-col cols="12" class="dashboard-col px-0 pb-0 mb-3 half-chart">
            <v-subheader class="ml-2">
              {{ lang.orders.month }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'orders' })"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <OrdersChart />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="dashboard-col px-0 pb-0 half-chart">
            <v-subheader class="ml-2">
              {{ lang.customers.month }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'customers' })"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <CustomersChart />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="permissions.scheduler" class="pa-0">
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="dashboard-col home-next-schedules">
            <v-subheader>
              {{ lang.scheduler.next }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'scheduler' })"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <Schedules :type="1" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="dashboard-col home-recent-schedules">
            <v-subheader>
              {{ lang.scheduler.recent }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'scheduler' })"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <Schedules :type="2" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* import NewCustomers from '@/components/home/templates/NewCustomers'
import Featured from '@/components/home/templates/Featured' */
import RecentOrders from '@/components/home/templates/RecentOrders'
import OrdersChart from '@/components/home/templates/OrdersChart'
import CustomersChart from '@/components/home/templates/CustomersChart'
import Schedules from '@/components/home/templates/Schedules'

import appdata from '@/mixins/appdata'

export default {
  components: { RecentOrders, OrdersChart, CustomersChart, Schedules },
  mixins: [ appdata ],
  methods: {
    matchLucky (range) {
      let sorted = [],
          result = {}

      for (let i = 1; i <= 70; i++) {
        for (let i = 1; i <= range; i++) {
          let random = Math.floor(Math.random() * 8)
          if (random === 7) sorted.push(i)
        }
      }

      for (let i = 0; i < sorted.length; i++) {
        result[sorted[i]] = (result[sorted[i]] || 0) + 1
      }

      // eslint-disable-next-line no-unused-vars
      return Object.entries(result).filter(([key, value]) => value === 7).map(lck => lck[0])
    },
    startLucky (range, matches) {
      var sorted = [],
          result = {}

      for (let i = 1; i <= 700; i++) {
        sorted = [ ...sorted, ...this.matchLucky(range) ]
      }

      for (let i = 0; i < sorted.length; i++) {
        result[sorted[i]] = (result[sorted[i]] || 0) + 1
      }

      result = Object.entries(result).sort((a, b) => b[1] - a[1])
      result = result.map(lucky => lucky[0])
      result = result.slice(0, matches)
      result = result.sort((a, b) => a - b)

      let again = confirm(`Boa Sorte ! \n\n${result.join(', ')} \n\nTentar Novamente?`)
      if (again) this.startLucky(range, matches)
    },
    Lucky () {
      var proceed = confirm("[LOTERIA] Parabéns, você está com sorte hoje, deseja prosseguir ?")
      if (proceed) {
        var range = prompt("[LOTERIA] Qual o número maximo da cartela ?", "60");
        if (range) {
          var matches = prompt("[LOTERIA] Quantos números por jogada ?", "6");
          if (matches) {
            range = parseInt(range)
            matches = parseInt(matches)
            this.startLucky(range, matches)
          }
        }
      }
    }
  }
}
</script>

<style src="@/components/home/styles/index.scss" lang="scss"/>
